export default __webpack_public_path__ + "static/media/WJK_Logo_for_SBL.3e57dd0b.png";